import React from 'react';
import FillHeightContainer from '@components/misc/FillHeightContainer';
import { CDN_URL } from '@utils/constants/url.constants';
import { useIsJCUser } from '@hooks/user.hook';

const LeaderboardEmptyState = () => {
  const { isJC } = useIsJCUser({ subjectId: undefined, generalPage: true });
  const copy = () => {
    return {
      header: isJC ? 'Hold up!' : 'Hold on, Astronauts!',
      body: isJC
        ? `We're getting the leaderboard ready for
      the next season. Stay tuned!`
        : `Our leaderboard is being prepared for the next season's epic
            adventure. Stay tuned for the big reveal!`,
    };
  };
  return (
    <FillHeightContainer bottomOffset={100}>
      <div className={'relative w-full h-full text-neutral-whiteboard'}>
        <div
          className={
            'absolute w-full max-w-[343px] left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2'
          }
        >
          {isJC === false && (
            <img
              src={CDN_URL + 'assets/images/leaderboard-below-3.svg'}
              alt={''}
              className={'w-[250px] max-w-full block mx-auto mb-7'}
            />
          )}
          <div className={'text-xl font-bold leading-7 text-center mb-4'}>
            {copy().header}
          </div>
          <div
            className={`${
              isJC === false ? 'font-bold' : ''
            } leading-6 text-center`}
          >
            {copy().body}
          </div>
        </div>
      </div>
    </FillHeightContainer>
  );
};

export default LeaderboardEmptyState;
